import { BrowserHistory } from "history";
import React, { useLayoutEffect, useState } from "react";
import { Router } from "react-router-dom";

interface CustomRouterProps {
  children: React.ReactNode;
  history: BrowserHistory;
}

function CustomRouter({ children, history }: Readonly<CustomRouterProps>) {
  const [state, setState] = useState({
    action: history.action,
    location: history.location,
  });

  useLayoutEffect(() => history.listen(setState), [history]);

  return (
    <Router
      location={state.location}
      navigationType={state.action}
      navigator={history}
    >
      {children}
    </Router>
  );
}

export default CustomRouter;
